import { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
  Avatar,
  Checkbox,
  Divider,
} from "@mui/material";

export default function CustomerFeedbackTracking() {
  return (
    <Typography
      variant="h2"
      fontWeight="bold"
      color="Dark"
      mb={1}
      mt={2}
      p={20}
      sx={{ color: "#4F46E5" }}
    >
      This module is under development. Please check back later.
    </Typography>
  );
}
